var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_143)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_131_143)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_131_143)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_131_143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0152 12.2913C15.9985 10.4898 17.528 9.61336 17.598 9.57255C16.7318 8.34121 15.3892 8.17296 14.9173 8.15955C13.7897 8.04385 12.6959 8.81742 12.1215 8.81742C11.5356 8.81742 10.651 8.17073 9.69764 8.18973C8.47082 8.20818 7.32312 8.90071 6.69365 9.97613C5.3946 12.1689 6.36345 15.3912 7.60804 17.1636C8.23062 18.0317 8.95811 19.0009 9.91033 18.9668C10.8419 18.9293 11.1899 18.3877 12.3141 18.3877C13.428 18.3877 13.7547 18.9668 14.7259 18.945C15.7257 18.9293 16.3551 18.073 16.9559 17.1972C17.6754 16.2022 17.9643 15.2224 17.9758 15.1721C17.9523 15.1643 16.0341 14.4505 16.0152 12.2913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1807 6.99359C14.6818 6.38266 15.0245 5.55151 14.9294 4.70805C14.2042 4.73935 13.2973 5.19713 12.775 5.79465C12.3129 6.32117 11.9002 7.18419 12.0068 7.99578C12.8215 8.05503 13.6579 7.59502 14.1807 6.99359Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.79999 4.8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_131_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.93991 4.64366)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_131_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.93991 4.64366)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_131_143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1263,
    height: 14.4,
    fill: "white",
    transform: "translate(6.07675 4.64366)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.9df43ed1f8a53c0164690bc56a5de1c5.svg";
export { ForwardRef as ReactComponent };